<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Association Membership</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <p>
      Customer:
      <a [routerLink]="['/customers', associationMember.customer_id.toString()]" target="_blank">
        {{ associationMember.customer_first_name }} {{ associationMember.customer_last_name }}
      </a>
      <br>
      Association:
      <a [routerLink]="['/associations', associationMember.association_id.toString()]" target="_blank">
        {{ associationMember.association_name }}
      </a>
      <br>
      <br>
      Date customer was added to association: {{ dateStringFromISO8601(associationMember.created_at) }}
      <br>
      <ng-container *ngIf="associationMember.association_reverification_period_days">
        Date association membership was last verified: {{ dateStringFromISO8601(associationMember.last_reverified_at) }}
        <br>
      </ng-container>
      Date association membership will expire:
      <span *ngIf="associationMember.next_automatic_removal_datetime">
        {{ dateStringFromISO8601(associationMember.next_automatic_removal_datetime) }}
      </span>
      <span *ngIf="!associationMember.next_automatic_removal_datetime" class="text-muted">
        None
      </span>
    </p>

    <hr>

    <ng-container *ngIf="associationMember.association_reverification_period_days && associationMember.next_automatic_removal_datetime">

      <p>
        <ng-container *ngIf="associationMember.is_pending_reverification">
          The reverification window began on {{ getReverificationWindowStart() }}.
        </ng-container>
        <ng-container *ngIf="!associationMember.is_pending_reverification">
          The reverification window will begin on {{ getReverificationWindowStart() }}.
        </ng-container>
      </p>

      <ng-container *ngIf="associationMember.is_pending_reverification">
        <div class="alert alert-info" role="alert" *ngIf="associationMember.association_verification_requirements">
          {{ associationMember.association_verification_requirements }}
        </div>

        <button type="button" class="btn btn-primary"
                (click)="handleReverify();">
          Reverify
        </button>
      </ng-container>

      <hr>

    </ng-container>

    <div class="alert alert-danger" role="alert">
      If this customer is removed from the association, they will lose any membership discounts linked to the association.
    </div>

    <div class="alert alert-danger" role="alert" *ngIf="errors.non_field_errors">
      {{ errors.non_field_errors }}
    </div>
    <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Close
    </button>
    <button type="button" class="btn btn-danger"
            (click)="handleRemove()"
            [disabled]="loadingSubmit"
            [class.disabled]="loadingSubmit">
      {{ loadingSubmit ? 'Loading...' : 'Remove Member' }}
    </button>
  </div>

</ng-container>
